import { Form, type FormInstance } from 'antd'

import AudioCard from '../AudioCard'
import UploadMenu from '../UploadMenu'
import MenuCard from '../MenuCard'

import { hoverBorderCls } from './constants'

import type { MusicGeneratorFormValuesV3 } from '@/pages/tad.ai/ai-music-generator/_types/form'
import type { $Enums } from '@prisma/client'

import { useGeneratorFormContext } from '@/pages/tad.ai/ai-music-generator/_blocks/GeneratorForm/_store'
import { getReferenceFormKeyByMusicType } from '@/pages/tad.ai/ai-music-generator/_blocks/GeneratorForm/_helpers/getReferenceFormKeyByMusicType'
import { useMusicFormStore } from '@/pages/tad.ai/ai-music-generator/_store/useMusicFormStore'


import { cls } from 'tagged-classnames-free';
interface ReferenceMusicCardProps {
  form: FormInstance<MusicGeneratorFormValuesV3>
  musicType: Extract<$Enums.MusicType, 'Instrumental' | 'Song' | 'Vocal'>
  title: string
}
function ReferenceMusicCard(props: ReferenceMusicCardProps) {
  const { form, musicType, title } = props

  const { historyModal } = useGeneratorFormContext()
  const setFormValues = useMusicFormStore((s) => s.setFormValues)
  const isUploading = useMusicFormStore((s) => s.ui.isUploading)

  const formName = getReferenceFormKeyByMusicType(musicType)

  const handleHistory = () => {
    historyModal.show({
      musicModel: 'V3',
      musicType,
      handleUse: (data) => {
        form.setFieldValue(formName as keyof MusicGeneratorFormValuesV3, data)
        setFormValues({ [formName]: data })
      },
    })
  }

  return (
    <div className={cls`flex flex-col gap-2`}>
      <div className={cls`text-f-text-quaternary  text-sm`}>{title}</div>
      <Form.Item
        hidden={
          !form.getFieldValue(formName as keyof MusicGeneratorFormValuesV3)
            ?.token
        }
        name={formName}
        noStyle
      >
        <AudioCard handleHistory={handleHistory} disabled={isUploading} />
      </Form.Item>
      <div className={cls` flex w-full items-center justify-between gap-x-2`}>
        <div
          className={cls`grid flex-1 grid-cols-1 gap-x-2  ${hoverBorderCls} rounded-[10px]`}
        >
          <UploadMenu form={form} musicType={musicType} />
          {/* <YoutubeMenu form={form} musicType={musicType} /> */}
        </div>
        <MenuCard
          icon='i-com--history'
          onClick={handleHistory}
          className={cls`${hoverBorderCls}`}
          disabled={isUploading}
        />
      </div>
    </div>
  )
}

export default ReferenceMusicCard
